export enum CoverageCodes {
  FixedElements = 'HOHWalls',
  FixedElementsFire = 'HOHWallsFire',
  FixedElementsFlooding = 'SAVFixedElementsFlooding',
  FixedElementsShortCircuit = 'HOHWallsOvervoltage',
  FixedElementsFlood = 'HOHWallsFlood',
  FixedElementsVandalism = 'FixedElementsVandalism',
  FixedElementsBurglary = 'HOHWallsTheft',

  Equipment = 'HOHMovables',
  EquipmentFire = 'HOHMovablesFire',
  EquipmentFlooding = 'SAVEquipmentFlooding',
  EquipmentShortCircuit = 'HOHMovablesOvervoltage',
  EquipmentFlood = 'HOHMovablesFlood',
  EquipmentVandalism = 'EquipmentVandalism',
  EquipmentBurglary = 'HOHMovablesTheft',

  Burglary = 'SAVBurglary',
  SolidElementsBreakage = 'HOHGlass',
  CivilLiabilityInsurance = 'HOHCivilPersonalLiability',
  SpecialistSupport = 'HOHHomeAssistance',
}
